import WatermarkChecklistFields from './WatermarkChecklistFields.component';

export default WatermarkChecklistFields;
